module.exports = "/_next/static/images/img__card-4-desktop-66aac48642d91eb8df13d62ae0781e89.png";